import { CollapsibleService } from './collapsible.service';
import { ResponsiveService } from '@/app/core/services/responsive.service';

import {
  Component,
  Input,
  OnInit,
  computed,
  effect,
  input,
} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'rdo-collapsible',
  imports: [NgClass],
  styleUrl: './collapsible.component.scss',
  standalone: true,
  host: {
    '[class.collapsible--collapsed]': 'isCollapsed()',
    '[class.collapsible--fixed]': 'isFixed()',
    '[class.collapsible--fixed-open]': 'isMobileOpen()',
  },
  template: ` <ng-content></ng-content> `,
})
export class CollapsibleComponent implements OnInit {
  public key = input.required<string>();

  protected isFixed = computed(() => this.responsiveService.isMobile());
  protected isCollapsed = computed(() => {
    // Use key() to get the signal value - this makes the computed reactive to key changes
    const currentKey = this.key();
    return this.service.getState(currentKey)() && !this.isFixed();
  });
  protected isMobileOpen = computed(() => this.service.isMobileOpen());

  constructor(
    public service: CollapsibleService,
    public responsiveService: ResponsiveService
  ) {}

  ngOnInit() {
    if (!this.key()) {
      throw new Error('CollapsibleComponent requires a "key" input.');
    }
    this.service.registerCollapsible(this.key(), false);
  }
}
